module.exports = __webpack_public_path__ + "img/support.541a7094.png";